import {useDispatch} from "react-redux";
import {useAppSelector} from "../../../redux/hooks/hooks";
import {selectAuthToken} from "../../../redux/slices/accountSlice";
import {Navigate, useLocation} from "react-router-dom";

interface IRequireAuthProps {
    children: any;
}

const RequireAuth = ({ children }: any) => {
    const dispatch = useDispatch()

    const token = useAppSelector(selectAuthToken);

    const storedToken = localStorage.getItem("userData");

    const location = useLocation();

    if (!token && !storedToken) {
        return <Navigate to={"/"} state={{ from: location }} />
    } else if (token && storedToken) {
    } else {
    }

    return (
        <>
            {children}
        </>
    )
}

export default RequireAuth;